import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Menu from '@material-ui/core/Menu';
import CheckIcon from '@material-ui/icons/Check';
import MenuItem from '@material-ui/core/MenuItem';
import FilterListIcon from '@material-ui/icons/FilterList';

import { setFilter } from '../../../state/order/actions'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: 10,
  }
}));

export default function Filtro(props) {
  const { label, filterField, filterOptions } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { filters } = useSelector(state => state.orders);
  const dispatch = useDispatch();
  const classes = useStyles();

  const _selection = filters[filterField];
  const handleClick = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (filter, value) => (e) => {
    e.preventDefault();
    filter !== undefined && dispatch(setFilter(filter, value));
    setAnchorEl(null);
  };

  const menuOptions = () => (
    filterOptions && filterOptions.map(({label, value}) => {
      const selected = _selection === value

      return (
        <MenuItem key={label} selected={selected} onClick={handleClose(filterField, value)}>
          {selected && <CheckIcon className={classes.icon} fontSize="small" />}
          {label}
        </MenuItem>
      );
    })
  )

  return (
    <>
      <div className={classes.root} onClick={handleClick}>
        <Typography variant="inherit">
          {label}&nbsp;
        </Typography>
        {filterOptions && <FilterListIcon fontSize="small" />}        
      </div>
      <Menu
        anchorEl={anchorEl}
        variant="menu"
        keepMounted
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        open={Boolean(anchorEl)}
        onClose={handleClose()}
      >
        {menuOptions()}
      </Menu>
    </>
  )
}